"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontSize = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var NumberInput_1 = require("@CommonFrontend/NumberInput/NumberInput");
var useSuggestedOptionsMenu_1 = require("./useSuggestedOptionsMenu");
var styles = __importStar(require("./FontSize.css"));
var FONT_SIZES = [14, 16, 18, 21, 24, 28, 32, 46, 48, 56, 64, 72, 80, 96, 120];
var suggestedOptions = FONT_SIZES.map(function (v) {
    return { value: v };
});
var FontSize = function (_a) {
    var value = _a.value, min = _a.min, max = _a.max, onChange = _a.onChange, onScale = _a.onScale;
    var _b = (0, NumberInput_1.useNumberInput)({
        label: "Font size",
        labelHidden: true,
        value: value ? value.abs : null,
        onChange: function (newAbs) { return onChange({ abs: newAbs, themeRef: null }); },
        size: kaleidoscope_1.TextInputSize.Medium,
        min: min,
        max: max,
    }), inputProps = _b.inputProps, stepperProps = _b.stepperProps;
    var _c = (0, useSuggestedOptionsMenu_1.useSuggestedOptionsMenu)({
        suggestedOptions: suggestedOptions,
        currentValue: value === null || value === void 0 ? void 0 : value.abs,
        onSelect: function (size) { return onChange({ abs: size, themeRef: null }); },
        width: 120,
    }), openMenu = _c.openMenu, inputRef = _c.inputRef, wrapperRef = _c.wrapperRef, menuComponent = _c.menuComponent;
    var onStepperChange = function (direction) {
        if (value === null) {
            onScale(function (currValue) {
                var newAbs = Math.min(Math.max({ up: currValue.abs + 1, down: currValue.abs - 1 }[direction], min), max);
                return { abs: newAbs, themeRef: null };
            });
        }
        else {
            stepperProps.onChange(direction);
        }
    };
    return (react_1.default.createElement("div", { className: styles.fontSizeContainer, ref: wrapperRef },
        react_1.default.createElement(NumberInput_1.NumberInputWrapper, null,
            react_1.default.createElement(NumberInput_1.NumberInputArea, __assign({}, inputProps, { className: styles.fontSizeInput, onClick: function () {
                    openMenu();
                }, ref: inputRef })),
            menuComponent,
            react_1.default.createElement(NumberInput_1.NumberStepper, __assign({}, stepperProps, { onChange: onStepperChange })))));
};
exports.FontSize = FontSize;
